import { Component } from '@ecs/Component';

export class SelectionBox implements Component {
  readonly type = 'SelectionBox';

  constructor(
    public active: boolean = false,
    public x1: number = 0,
    public y1: number = 0,
    public x2: number = 0,
    public y2: number = 0
  ) {}
}
